import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Andy Martinez
 * id C1313085-6C7F-4D60-A278-A39361B57DA9
 * name camera-metering-spot
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/camera-metering-spot.svg
 * tags
 * - Photography 
 */
export const CameraMeteringSpotIcon = createSvgIcon(<><path d="M4,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4M4,6V18H20V6H4M12,10.5A1.5,1.5 0 0,1 13.5,12A1.5,1.5 0 0,1 12,13.5A1.5,1.5 0 0,1 10.5,12A1.5,1.5 0 0,1 12,10.5Z" /></>, 'CameraMeteringSpotIcon');
export default CameraMeteringSpotIcon